// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1kg4-","video__player":"Video_video__player__10-bq","video__player--hidden":"Video_video__player--hidden__2Co26","refBox":"Video_refBox__1OulT"};